import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { ROUTE_PATHS } from '@constants/routes';

@Injectable({
  providedIn: 'root'
})
export class OptOutRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const queryParams = route.queryParams;
    this.router.navigate([ROUTE_PATHS.IMPORTED_OPT_OUT], { queryParams });
    return false;
  }
}
